import { render } from "./tabsList.vue?vue&type=template&id=837c8c2e&scoped=true"
import script from "./tabsList.vue?vue&type=script&lang=js"
export * from "./tabsList.vue?vue&type=script&lang=js"

import "./tabsList.vue?vue&type=style&index=0&id=837c8c2e&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/vas-web-client-pre/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-837c8c2e"]])